import { inputBaseClasses, MenuItem, Select, styled } from '@mui/material';

export const SelectStyled = styled(Select, {
  shouldForwardProp: (prop) => !['error', 'changed', 'changedColor'].includes(String(prop)),
})<{
  error?: boolean;
  changed?: boolean;
  changedColor?: string;
}>(({ theme, error, changed, changedColor }) => ({
  [`&.${inputBaseClasses.root}`]: {
    borderRadius: 12,
    background: theme.palette.background.input,
    border: '1px solid',
    borderColor: error
      ? theme.palette.error.main
      : changed
        ? (changedColor ?? '#F5841F')
        : theme.palette.borders.main,
  },
  [`& .${inputBaseClasses.input}`]: {
    padding: '8px 12px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiOutlinedInput-input': {
    paddingRight: '40px !important',
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - .18em)',
    right: 15,
  },
}));

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '8px 16px',
  background: '#171B2B',
  borderRadius: 8,
  marginBottom: '4px',
  '&:hover': {
    backgroundColor: '#22273F',
  },
  '&.Mui-selected': {
    backgroundColor: '#22273F' + ' !important',
    color: theme.palette.primary.contrastText + ' !important',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#22273F' + ' !important',
  },
}));
